import { render } from "./avolta-map.vue?vue&type=template&id=54c63e8b&ts=true"
import script from "./avolta-map.ts?vue&type=script&lang=ts"
export * from "./avolta-map.ts?vue&type=script&lang=ts"

import "./avolta-map.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/builds/elichens-avolta-connect/software/avolta-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__